import React from 'react';
import { createRoot } from 'react-dom/client';

// 各源文件沿用原有的 window.X 全局挂载方式互相依赖（非 ES module），
// 这里只负责按原 <script> 标签顺序 side-effect import，保证求值顺序不变。
// window.React 的挂载在 globals.js 里完成（必须作为独立模块最先被
// import，理由见该文件内注释——不能把赋值直接写在这个文件的顶层）。
import './globals.js';
import './mahjong.js';
import './tile-component.js';
import './app-components-1.js';
import './app-components-2.js';
import './quick-calc.js';
import './app-main.js';

const rootEl = document.getElementById('calc-root');
if (rootEl) {
  createRoot(rootEl).render(React.createElement(window.MahjongApp));
}
